const Index = () => import(/* webpackChunkName: "authentication" */ './index');
const Login = () => import(/* webpackChunkName: "authentication" */ './components/Login.vue');
const SignUp = () => import(/* webpackChunkName: "authentication" */ './components/SignUp.vue');
const Logout = () => import(/* webpackChunkName: "authentication" */ './components/Logout.vue');
const ForgotPassword = () => import(/* webpackChunkName: "authentication" */ './components/ForgotPassword.vue');
const ResetPassword = () => import(/* webpackChunkName: "authentication" */ './components/ResetPassword.vue');

export default [
  {
    path: '/login',
    name: 'authentication-login',
    component: Login,
    props: true,
    meta: { public: true },
  },
  {
    path: '/',
    name: 'login',
    component: Index,
    title: 'Login',
    redirect: { name: 'authentication-login' },
    children: [
      {
        path: '/signup',
        name: 'signup',
        component: SignUp,
        props: true,
        meta: { public: true },
      },
      {
        path: ':id/signup',
        name: 'signup',
        component: SignUp,
        props: true,
        meta: { public: true },
      },
      {
        path: '/forgot',
        name: 'forgot',
        component: ForgotPassword,
        props: true,
        meta: { public: true },
      },
      {
        path: '/resetPassword',
        name: 'resetPassword',
        component: ResetPassword,
        props: true,
        meta: { public: true },
      },
    ],
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout,
  },
]
